// CRUDMixin.js
import { Auth } from '@/database';
import { debounce } from 'lodash';
import { mapGetters } from 'vuex'
import { Notify } from 'quasar'

export default {
    data() {
        return {
            api: new Auth(),
            newRow: {},
            editRow: {},
            create_loading: false,
            create_error: null,
            create_error_json: null,
            delete_loading: false,
            delete_error: null,
            edit_loading: false,
            edit_error: null,
            csv_uploading: false,
            csv_upload_error: null,
            csv_downloading: false,
            excel_downloading: false,
            excel_download_error: null,
            excel_uploading: false,
            excel_upload_error: null,
            loading: false,
            table_rows: [],
            table_stats: {
                count: 0,
            },
            formset_loading: false,
            formset_error: null,
            cubeFilters: {},
            schema: {},
        }
    },
    props: {
        context: {
            type: Object,
            default: () => ({}),
        },
        filters: {
            type: Array,
            default: () => [],
        },
    },
    async created(){
        // Use the first column for order by as default
        if (this.render_mode === 'edit') {
            await this.getSchema();
            return;
        }
    },
    computed: {
        ...mapGetters({vuexContext: 'getStoredObject', }),
        actionParams() { 
            return {
                setTableRowValue: this.setTableRowValue,
                setTableRow: this.setTableRow,
                table_rows: this.table_rows,
                api: this.api,      
                saveTableRows: this.saveTableRows,
                load: this.load,
                context: {...this.context, ...this.vuexContext},
                filters: this.filters,
            }
        },
    },
    methods: {
        get_load_query() {
            const query_str = {};
            console.log('[CRUDTable] page_size_:', this.page_size_, '| page_size prop:', this.page_size);
            const pageSize = Number(this.page_size_) || Number(this.page_size);
            if (pageSize) {
                query_str.offset = (this.page_number - 1) * pageSize;
                query_str.limit = pageSize;
            }
            this.joined_columns = this.columns.filter((col) => (col?.key || '').includes('.')).map((col) => col.key);
            if (this.search_term) query_str.search = this.search_term;
            let filters = this.filters.concat(Object.entries(this.columnFilters||{}).filter((en) => en[1]).map(([key, value]) => {return {member: key, operator: 'equals', values: [value]}}));
            filters = filters.concat(Object.entries(this.searchFilters||{}).filter((en) => en[1]).map(([key, value]) => {return {member: key, operator: 'contains', values: [value]}}));
            if (this.cubeFilters) Object.entries(this.cubeFilters).forEach(([key, moreFilters]) => { filters = filters.concat(moreFilters)})
            if (filters && Object.keys(filters).length > 0) query_str.filter_by = JSON.stringify(filters);
            if (this.order_by?.column) query_str.order_by = JSON.stringify([this.order_by]);
            if (this.joined_columns.length > 0) query_str.joined_columns = JSON.stringify(this.joined_columns);
            return query_str;
        },
        async load(load_reason='load') {
            // start but dont await loadStats
            console.log(`Loading ${this.crud_endpoint} for ${this.$options.name || 'UnknownComponent'}: ${load_reason}`);
            this.loading = true;
            this.loadStats();
            if (this.get) {
                await this.get(this);
            } else {
                const query_str = this.get_load_query();
                const response = await this.api.fetch(this.crud_endpoint + '?' + new URLSearchParams(query_str), {method: 'GET'});
                if (response.status == 200) {
                    const json_response = await response.json();
                    this.table_rows = json_response.output.data.map((row, $row_ind) => {return {...row, $row_ind}});
                } else if (response.status == 400) {
                    const {detail} = await response.json();
                    console.log('Error loading data', detail);
                    if (detail.type === 'InvalidFilterError') {
                        // Clear the filters and reload
                        alert('Invalid Filter, clearing filters ---\n' + detail.message);
                        this.cubeFilters = {};
                        return this.load('reload-after-invalid-filter');
                    }
                    this.load_error = "Bad Request: " + (json_response.message || "An unexpected error occurred.");
                } else {
                    alert('Error loading data');
                }
            }
            this.table_rows.forEach(row => row.$selected = false);
            this.loading = false;
        },
        loadDebounced: debounce(async function() {
            await this.load();
        }, 1000), // Debounce the load function to avoid excessive calls
        async loadStats() {
            const query_str = this.get_load_query();
            query_str.stats = JSON.stringify(['count', 'min', 'max', ...this.footerStats || []]);
            const response = await this.api.fetch(this.crud_endpoint+'stats/' + '?' + new URLSearchParams(query_str), {method: 'GET'});
            if (response.status == 200) {
                this.table_stats = await response.json();
            } else {
                alert('Error loading stats (totals)');
            }

        },
        async getSchema() {
            // Get the schemaf or the current table
        if (!this.crud_endpoint) return
            const response = await this.api.fetch(this.crud_endpoint + 'schema/', {method: 'GET'});
            if (response.status == 200) {
                this.schema = await response.json();
            }
            else {
                console.error('Error loading schema', response.statusText);
                return {};
            }
        },
        
        async createRow(openEditDialog=false) {
            this.create_loading = true;
            try {
                let response;
                if (this.post) {
                    const success = await this.post(this);
                    if (!success) return;
                } else {
                    const joined_columns = this.columns.filter((col) => (col?.key || '').includes('.')).map((col) => col.key);
                    console.log(joined_columns)
                    // Remove joined_columns keys from newRow
                    const newRow = {...this.newRow};
                    joined_columns.forEach((col) => { if (newRow[col]!==undefined) delete newRow[col] });
                    console.log(newRow)
                    response = await this.api.fetch(this.crud_endpoint, {
                        method: 'POST',
                        body: JSON.stringify(newRow),
                    });
        
                    // Check if the response status indicates failure
                    if (!response.ok) {
                        const errorDetail = await response.json();
                        if (response.status === 500) {
                            // Handle 500 Internal Server Error specifically
                            this.create_error = "Internal Server Error: " + (errorDetail.detail || "An unexpected error occurred.");
                        } else if (response.status === 400) {
                            // Handle 400 Bad Request specifically JSON DECODE of the detail
                            this.create_error =  errorDetail.detail;
                        } else {
                            // Handle other HTTP errors
                            this.create_error = errorDetail.detail || `Error creating row: ${response.statusText}`;
                        }
                        this.create_loading = false;
                        return;
                    } else if (response.status === 200) {
                        if (openEditDialog) {
                            // If the edit dialog is open, set the editRow to the newly created row
                            this.editRow = await response.json();
                            if (this.editAfterCreate) {
                                this.editDialog = true;
                            }
                        }
                    }
                }
                // Reload after successful creation
                await this.load();
                this.addDialog = false;
                this.newRow = {};
            } catch (error) {
                // Catch and handle any unexpected exceptions
                this.create_error = `Network or unexpected error: ${error.message}`;
            } finally {
                this.create_loading = false;
            }
        },        
        async deleteRows(rows) {
            this.delete_loading = true;
            try {
                let response;
                if (this.del) {
                    await this.del(this, rows);
                } else {
                    rows = rows.map((row) => {
                        // Remove $ properties from row
                        return Object.fromEntries(Object.entries(row).filter(([key]) => !key.startsWith('$')));
                    });
                    response = await this.api.fetch(this.crud_endpoint, {
                        method: 'DELETE',
                        body: JSON.stringify(rows),
                    });
        
                    // Check if the response status indicates failure
                    if (!response.ok) {
                        const errorDetail = await response.json();
                        if (response.status === 500) {
                            // Handle 500 Internal Server Error specifically
                            this.delete_error = "Internal Server Error: " + (errorDetail.detail || "An unexpected error occurred.");
                        } else {
                            // Handle other HTTP errors
                            this.delete_error = errorDetail.detail || `Error deleting rows: ${response.statusText}`;
                        }
                        this.delete_loading = false;
                        return;
                    } else if (response.status === 200) {
                        // If the edit dialog is open, set the editRow to the newly created row
                        this.delete_error = null;
                    }
                }
                // Reload after successful deletion
                await this.load();
                this.deleteDialog = false;

            } catch (error) {
                // Catch and handle any unexpected exceptions
                this.delete_error = `Network or unexpected error: ${error.message}`;
            } finally {
                this.delete_loading = false;
            }
        },

        async saveEditRow() {
            this.edit_loading = true;
            try {
                let response;
                if (this.put) {
                    const success = await this.put(this);
                    if (!success) return;
                } else {
                    const joined_columns = this.columns.filter((col) => (col?.key || '').includes('.')).map((col) => col.key);
                    // Remove joined_columns keys from editRow
                    console.log(this.editRow)
                    const editRow = Object.fromEntries(Object.entries(this.editRow).filter(([key]) => !key.startsWith('$')));
                    joined_columns.forEach((col) => { if (editRow[col]!==undefined) delete editRow[col] });
                    response = await this.api.fetch(this.crud_endpoint, {
                        method: 'PUT',
                        body: JSON.stringify(editRow),
                    });
        
                    // Check if the response status indicates failure
                    if (!response.ok) {
                        const errorDetail = await response.json();
                        if (response.status === 500) {
                            // Handle 500 Internal Server Error specifically
                            this.edit_error = "Internal Server Error: " + (errorDetail.detail || "An unexpected error occurred.");
                        } else {
                            // Handle other HTTP errors
                            this.edit_error = errorDetail.detail || `Error saving row: ${errorDetail}`;
                        }
                        this.edit_loading = false;
                        return;
                    } else if (response.status === 200) {
                        this.edit_error = null;
                        this.editRow = await response.json();
                    }
                }
                // Reload after successful save
                await this.load();
            } catch (error) {
                // Catch and handle any unexpected exceptions
                this.edit_error = `Network or unexpected error: ${error.message}`;
            } finally {
                this.edit_loading = false;
            }
        },        
        
        // GETTING CUBE INPUT
        async query(query){
            const auth = new Auth()
            const query_return_object = await auth.fetch(
                `cube/v1/query/${query['model_id']}`, 
                {
                    method: 'POST',
                    body: JSON.stringify({query, query_params: {}}),
                }
            ).then(response => response.json())
            return query_return_object.output.data
        },

        async getFirstRow(query){
            let data = await this.query(query)
            // Remove table_name
            data =  Object.fromEntries(Object.entries(data[0]).map(([key, value]) => [key.split('.')[1], value]))
            return data
        },
    
        downloadCSV: async function(){
            this.csv_downloading = true;
            const query_str = this.get_load_query();
            const response = await this.api.fetch(this.crud_endpoint + 'csv/' + '?' + new URLSearchParams(query_str), {method: 'GET'});

            if (response.status == 200) {
                const csv = await response.text();
                const blob = new Blob([csv], {type: 'text/csv'});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'data.csv';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            } else {
                alert('Error loading data');
            }
            this.csv_downloading = false;
        },

        
       downloadExcel: async function () {
            this.excel_downloading = true;
            const query_str = this.get_load_query();
            const response = await this.api.fetch(
                this.crud_endpoint + 'excel/' + '?' + new URLSearchParams(query_str),
                { method: 'GET' }
            );
            if (response.status == 200) {
                const blob = await response.blob();
                // extract filename from Content-Disposition header, fallback to default
                const disposition = response.headers.get('Content-Disposition');
                const filename = disposition
                    ? disposition.split('filename=')[1]?.replace(/"/g, '')
                    : 'download.xlsx';
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            } else {
                alert('Error loading data');
            }
            this.excel_downloading = false;
        },

        saveTableRows: async function(){
            // Rows to save 
            const rows = this.table_rows//.filter((row) => row.$changed || row.$created || row.$deleted || row.$selected);
            this.formset_loading = true;
            try {
                let response;
                if (this.formset) {
                    await this.formset(this, rows);
                } else {
                    response = await this.api.fetch(this.crud_endpoint + 'formset/', {
                        method: 'POST',
                        body: JSON.stringify(rows),
                    });
        
                    // Check if the response status indicates failure
                    if (!response.ok) {
                        const errorDetail = await response.json();
                        if (response.status === 500) {
                            // Handle 500 Internal Server Error specifically
                            this.formset_error = "Internal Server Error: " + (errorDetail.detail || "An unexpected error occurred.");
                        } else {
                            // Handle other HTTP errors
                            this.formset_error = errorDetail.detail || `Error saving rows: ${errorDetail}`;
                        }
                        this.formset_loading = false;
                        return;
                    } else if (response.status === 200) {
                        this.formset_error = null;
                    }
                }
                // Reload after successful save
                await this.load();
            } catch (error) {
                // Catch and handle any unexpected exceptions
                console.error('Error during saveTableRows:', error);
                this.formset_error = `Network or unexpected error: ${error.message}`;
            } finally {
                this.formset_loading = false;
            }

        },


        uploadCSV: async function(upload_script_id){
            if (upload_script_id == true){
                upload_script_id=null
            }
            this.csv_uploading = true;
            this.$refs.file.click();
            const file = this.$refs.file.files[0];
            console.log(file)
            const formData = new FormData();
            formData.append('file', file);
            // console.log('upload_script_id', upload_script_id)
            if (upload_script_id) formData.append('upload_script_id', upload_script_id);
            const response = await this.api.uploadFile(this.crud_endpoint + 'csv/', {
                method: 'POST',
                body: formData,
            });
            if (response.status == 200) {
                await this.load();
            } else if (response.status == 400) {
                const errorDetail = await response.json();
                this.csv_upload_error = errorDetail.detail || 'Error uploading CSV';
                alert(JSON.stringify(this.csv_upload_error))
            } else {
                this.csv_upload_error = 'Error uploading CSV';
                alert('Error loading data');
            }
            this.csv_uploading = false;

        },



        uploadExcel: async function(upload_script_id){
            if (upload_script_id == true){
                upload_script_id=null
            }
            this.excel_uploading = true;
            this.$refs.file.click();
            const file = this.$refs.file.files[0];
            console.log(file)
            const formData = new FormData();
            formData.append('file', file);
            // console.log('upload_script_id', upload_script_id)
            if (upload_script_id) formData.append('upload_script_id', upload_script_id);
            const response = await this.api.uploadFile(this.crud_endpoint + 'excel/', {
                method: 'POST',
                body: formData,
            });
            if (response.status == 200) {
                await this.load();
            } else if (response.status == 400) {
                const errorDetail = await response.json();
                this.excel_upload_error = errorDetail.detail || 'Error uploading Excel';
                alert(JSON.stringify(this.excel_upload_error))
            } else {
                this.excel_upload_error = 'Error uploading Excel';
                alert('Error loading data');
            }
            this.excel_uploading = false;

        },
        setTableRowValue(row_ind, column_key, value) {
            const row = this.table_rows[row_ind];
            this.table_rows = [
                ...this.table_rows.slice(0, row_ind), 
                {...row, [column_key]: value, $changed: true }, 
                ...this.table_rows.slice(row_ind + 1)
            ];
        },
        setTableRow(row_ind, row) {
            this.table_rows = [
                ...this.table_rows.slice(0, row_ind),
                {...this.table_rows[row_ind], ...row, $changed: true },
                ...this.table_rows.slice(row_ind + 1)
            ];
        },
    },
    watch: {
        crud_endpoint(){
            if (this.render_mode === 'edit') this.getSchema();
        },
        filters: {
            handler(newFilters, oldFilters) {
                if (JSON.stringify(newFilters) !== JSON.stringify(oldFilters)) {
                    console.log('Old filters:', oldFilters);
                    console.log('New filters:', newFilters);
                    this.load('filters-changed');
                }
            },
            deep: true,
        },
        table_rows: {
            handler(newRows, oldRows) {
                if (oldRows?.length == 0) return; // Skip if no old rows
                this.columns.forEach((column) => {
                    if (column.trigger) {
                        newRows.forEach((row, index) => {
                            if (oldRows[index] && row[column.key] !== oldRows[index][column.key]) {
                                console.log(`Triggering column ${column.key} for row ${index}`);
                                column.trigger({row});
                            }
                        });
                    }
                });
            },
            deep: true, // Required to watch nested properties
        },  
    }
}
